export default __webpack_public_path__ + "static/media/pellets.55144356.jpg";